import { FC } from "react";
import { Box } from "@mui/material";
import {
    Modal,
    ModalTitle,
    ModalContent,
    ModalActions,
    Button,
    Loader,
    Settings,
    SettingsItem,
} from "ui";
import { useDispatch } from "react-redux";
import { modalHide } from "app/App/actions";
import useRequest from "api/useRequest";
import { orderLocationModulesDatatransGateway } from "app/Order/Locations/actions";

type TDatatransUpdateModal = {
    locationId: number;
    onClose: Function;
};

const DatatransUpdateModal: FC<TDatatransUpdateModal> = ({ locationId }) => {
    const dispatch = useDispatch();
    const { currentData, isPending } = useRequest(
        orderLocationModulesDatatransGateway(locationId),
    );

    const handleClose = () => {
        dispatch(modalHide("DatatransUpdateModal"));
    };

    if (isPending || !currentData.data) {
        return <Loader />;
    }

    return (
        <Modal open maxWidth="xl" fullWidth onClose={handleClose}>
            <ModalTitle onClose={handleClose}>Datatrans</ModalTitle>

            <ModalContent sx={{ p: 2 }}>
                <Settings>
                    <SettingsItem label="UUID">
                        <pre
                            style={{
                                margin: 0,
                            }}
                        >
                            {currentData.data.uuid}
                        </pre>
                    </SettingsItem>
                </Settings>
            </ModalContent>
            <ModalActions>
                <Box display="flex" width="100%" textAlign="right">
                    <Button
                        onClick={handleClose}
                        color="inherit"
                        variant="text"
                        sx={{ mr: 1 }}
                    >
                        Cancel
                    </Button>
                </Box>
            </ModalActions>
        </Modal>
    );
};

export default DatatransUpdateModal;
